<template>
  <div class="affiliate-page">
    <HeroSection
      :title="`${instructor.name.split(' ')[0]} loves 365 Data Science`"
      title-class="h1"
      subtitle="Do you want to know why?"
      :desc="instructor.description"
      button
      button-title="Start Your Career"
      :image-url="`hero-${name}.jpg`"
      columns="col-7"
      class-name="affiliate"
      @buttonClicked="subscribe"
    >
      <div slot="stats" class="hero-stats">
        <div class="instructor-signature">
          <span>{{ instructor.signature }}</span>
          <img v-if="instructor.signatureCompany" :src="`${$config.imagesUrl}/companies/${instructor.signatureCompany}`" class="signature-company instructor-signature-company-logo">
        </div>
      </div>
    </HeroSection>
    <div class="section">
      <div class="container">
        <h2 class="h2 col-8">
          Start Your Data Science Career with 365 Data Science and {{ instructor.name }}
        </h2>
        <img
          loading="lazy"
          class="offset-1 col-10"
          :src="`${require(`../assets/images/screens-${name}.png`)}`"
          :alt="`screens-${name}`"
        >
      </div>
    </div>
    <div class="site-section main-dark-light">
      <div class="container about">
        <div class="row">
          <div class="col col-6">
            <h2 class="h3">
              {{ instructor.shortDescription }}
            </h2>
            <div class="skills">
              <div v-for="(skill, i) in instructor.skillBoxes" :key="i" class="skill-box caption">
                {{ skill }}
              </div>
            </div>
          </div>
          <div class="col col-6">
            <p class="body-1">
              {{ instructor.specialization }}
            </p>
            <div class="stats">
              <div class="stat">
                <div>{{ instructor.experience }}</div>
                <span>Years <br> of Experience</span>
              </div>
              <div class="stat">
                <div>{{ instructor.signature.split(' ')[0] }}</div>
                <span>Subscribers <br> on YouTube</span>
              </div>
            </div>
          </div>
        </div>
        <div class="author-quote">
          <div class="img-holder">
            <img loading="lazy" :src="`${$config.imagesUrl}/team/${instructor.image}`" :alt="instructor.name">
          </div>
          <div class="info">
            <div class="subtitle">
              {{ instructor.quote }}
            </div>
            <p>{{ instructor.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="site-section gray">
      <ProgramCards
        light class-name="affiliate" title="A Curriculum that Takes You From Beginner To A Certified Professional"
      />
      <Reviews />
    </div>
    <div class="site-section dark">
      <Trusted
        title="Trusted by over 3,000,000 students"
        subtitle="We provide high-quality, affordable training to open new opportunities for aspiring data professionals all over the world."
        button
        button-title="Start Your Career"
        image-desktop="professionals.webp"
        image-mobile="professionals-mobile.webp"
        @buttonClicked="subscribe"
      />
      <div class="container">
        <div class="graduates-work">
          <h3 class="col-8 h2">
            Our Graduates Work At Top Companies Around the Globe
          </h3>
          <div class="logos col-12">
            <span class="logo">
              <LogoVisa />
            </span>
            <span class="logo">
              <LogoWalmart />
            </span>
            <span class="logo">
              <LogoTesla />
            </span>
            <span class="logo">
              <LogoCitibank />
            </span>
            <span class="logo">
              <LogoOracle />
            </span>
            <span class="logo">
              <LogoPaypal />
            </span>
            <span class="logo">
              <LogoAmazon />
            </span>
          </div>
        </div>
      </div>
      <LimitedOffer
        :options="limitedOfferOptions"
        :features="limitedOfferFeatures"
        @subscribe="subscribe"
      />
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import ProgramCards from './Landing/ProgramCards';
import Reviews from './Landing/Reviews';
import Trusted from './Landing/Trusted';
import LimitedOffer from './Landing/LimitedOffer';
import LogoVisa from '../assets/svg/companies/logo-visa.svg?vue-component';
import LogoWalmart from '../assets/svg/companies/logo-walmart.svg?vue-component';
import LogoTesla from '../assets/svg/companies/logo-tesla.svg?vue-component';
import LogoCitibank from '../assets/svg/companies/logo-citibank.svg?vue-component';
import LogoOracle from '../assets/svg/companies/logo-oracle.svg?vue-component';
import LogoPaypal from '../assets/svg/companies/logo-paypal.svg?vue-component';
import LogoAmazon from '../assets/svg/companies/logo-amazon.svg?vue-component';

export default {
  components: {
    HeroSection,
    ProgramCards,
    Reviews,
    Trusted,
    LimitedOffer,
    LogoVisa,
    LogoWalmart,
    LogoTesla,
    LogoCitibank,
    LogoOracle,
    LogoPaypal,
    LogoAmazon,
  },
  mixins: [global],
  props: {
    seo: { type: Object, required: true },
    instructor: { type: Object, default: () => {}, required: false },
    stats: { type: Object, default: () => {}, required: false },
  },
  data() {
    return {
      page: {},
      name: '',
      limitedOfferOptions: {
        title: 'Save 60% With Annual Subscription',
        promoPlanType: 'annual',
        comparisonPlanType: 'monthly',
        comparisonPlanBilledText: 'Billed Monthly',
        promoPlanBilledText: 'Billed Annually',
        regularPrice: '$36.00',
        discountedPrice: '$14.50',
        billedComparisonPrice: '$36',
        discountedPriceCharge: '/month',
        billedComparisonCharge: '/month',
        promoPlanSubscribeClass: 'subscribe-annual',
        comparisonSubscribeClass: 'subscribe-monthly',
        promoPlanButtonText: 'Save 60% Now',
        comparisonPlanButtonText: 'Start Your Career',
      },
      limitedOfferFeatures: [
        {
          name: '',
        },
        {
          name: 'Downloadables',
        },
        {
          name: 'Dedicated Support',
        },
        {
          name: 'New Content',
        },
        {
          name: '',
        },
        {
          name: 'Portfolio advice',
        },
        {
          name: 'Certificate',
        },
        {
          name: 'Resume feedback',
        },
      ],
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
      {
        key: 'Person',
        values: {
          name: this.instructor.name,
          url: `${this.$config.siteUrl}${this.$route.fullPath}`,
          image: {
            '@type': 'ImageObject',
            url: `${this.$config.imagesUrl}/team/${this.instructor.image}`,
            caption: `${this.instructor.name}'s image`,
          },
        },
      },
    ]);

    const brightcoveSrc = [
      { src: 'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js' },
      { src: 'https://players.brightcove.net/videojs-quality-menu/1/videojs-quality-menu.min.js' },
    ];

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [
        ...brightcoveSrc,
        linkedData,
      ],
    };
  },
  created() {
    this.page = this.seo;
    this.page.fullPath = `${this.$config.siteUrl}${this.$route.fullPath}`;
    this.name = this.instructor.name.split(' ')[0].toLowerCase();
    this.limitedOfferFeatures[0].name = `${this.stats.rounded.videoDuration} Hours of video`;
    this.limitedOfferFeatures[4].name = `${this.stats.rounded.exercises}+ Exercises`;
  },
  methods: {
    subscribe() {
      return this.$router.push({ path: '/checkout/', query: { plan: 'annual', coupon: this.instructor.coupon } });
    },
  },
};
</script>

<style lang="scss">
.affiliate-page {
  .hero-stats {
    font-size: 21px;
    margin-bottom: var(--spacing-32);

    svg {
      width: 90px;
      margin-left: 15px;

      path[fill]:not(:nth-child(2)) {
        fill: var(--main-light);
      }
    }
  }

  .section {
    padding-top: 135px;

    .h2 {
      max-width: 760px;
      margin: 0 auto 52px;
      text-align: center;
    }

    img {
      max-width: 100%;
    }
  }

  .site-section {
    &.main-dark-light {
      padding: 340px 0 120px;
      margin-top: -280px;
      background-color: var(--main-dark-light-1);
      color: var(--main-light);
    }

    &.gray {
      background-color: var(--main-light-shade-1);
    }

    &.dark {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }

  .about {
    .h3 {
      text-transform: capitalize;
    }

    .body-1 {
      margin: 0;
    }

    .skills {
      display: flex;
      flex-wrap: wrap;
      max-width: 450px;
      margin-top: var(--spacing-28);

      > div {
        padding: var(--spacing-4) var(--spacing-16);
        margin: 0 var(--spacing-12) var(--spacing-16) 0;
        font-size: 14px;
        border: 1px solid var(--main-light);
        border-radius: 5px;
        color: var(--main-light-shade-4);
      }
    }

    .stats {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: var(--spacing-28);

      .stat {
        display: flex;
        align-items: center;

        div {
          font-size: 70px;
          font-weight: 500;
          margin-right: var(--spacing-12);
        }

        span {
          font-size: 18px;
          color: var(--main-light-shade-4);
        }
      }
    }

    .author-quote {
      margin-top: var(--spacing-120);
      padding: 72px;
      display: flex;
      align-items: flex-start;
      background-color: var(--main-dark);

      .img-holder {
        padding-right: var(--spacing-36);

        img {
          max-width: 400px;
          border-radius: 10px;
        }
      }

      .info {
        padding-left: var(--spacing-36);
      }

      .subtitle {
        color: var(--main-light-shade-4);
        margin-bottom: var(--spacing-24);

        &:before {
          content: '';
          width: 35px;
          height: 27px;
          background-image: url('../assets/images/icon-quote-testimonial-story.png');
          image-rendering: -webkit-optimize-contrast;
          background-size: cover;
          display: block;
          margin-bottom: var(--spacing-24);
        }
      }

      p {
        font-size: 24px;
      }
    }
  }

  .program-cards,
  .reviews,
  .trusted,
  .graduates-work,
  .limited-offer {
    padding-top: var(--spacing-80);
    padding-bottom: var(--spacing-80);
  }

  .program-cards {
    .h2 {
      max-width: 760px;
    }

    .modules {
      .module {
        padding: var(--spacing-44);
        margin-bottom: var(--spacing-24);
        box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);

        .h3 {
          max-width: 100%;
        }
      }
    }
  }

  .trusted {
    .container {
      .subtitle {
        font-size: 18px;
        max-width: 630px;
      }
    }
  }

  .graduates-work {
    .h2 {
      color: var(--main-light);
      text-align: center;
      margin: 0 auto;
    }

    .logos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: var(--spacing-48);

      .logo {
        padding: var(--spacing-28) 40px;
        background-color: var(--main-dark-light-1);
        box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
        border-radius: 7px;
        margin: var(--spacing-16);
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 130px;

          path[fill] {
            fill: #CBCBCB;
          }
        }
      }
    }
  }

  .limited-offer {
    .container {
      padding: 80px 190px;
      background-color: var(--main-dark-light-1);
      border-radius: 7px;
    }

    hr {
      max-width: 100%;
    }

    .plan-features {
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 40px;
      padding-left: 0;
      white-space: nowrap;
    }
  }
}

@include bp($bp-laptop) {
  .affiliate-page .about .stats .stat div {
    font-size: 54px;
  }
}

@include bp($bp-mobile) {
  .affiliate-page {
    .hero-stats {
      font-size: 16px;

      svg {
        margin-left: 6px;
      }
    }

    .site-section {
      &.main-dark-light {
        padding: 180px 0 0;
        margin-top: -100px;
      }

      &.dark {
        padding: 0;
      }
    }

    .about {
      text-align: center;

      .skills {
        align-items: center;
        justify-content: center;
        margin-bottom: 52px;
      }

      .body-1 {
        font-size: 18px;
      }

      .stats {
        justify-content: center;

        .stat {
          flex-direction: column;

          &:first-of-type {
            margin-right: 65px;

            span {
              max-width: 100px;

              br {
                display: none;
              }
            }
          }

          div {
            font-size: 38px;
          }

          span {
            font-size: 16px;
          }
        }
      }

      .author-quote {
        flex-direction: column;
        margin-left: -24px;
        margin-right: -24px;
        padding: var(--spacing-80) var(--spacing-24);
        text-align: left;

        .img-holder {
          padding: 0;
          margin-bottom: 52px;

          img {
            max-width: 100%;
          }
        }

        .info {
          padding-left: 0;
        }
      }
    }

    .program-cards {
      padding-top: 0;
    }

    .reviews,
    .graduates-work {
      padding: 0;
    }

    .trusted {
      padding-bottom: var(--spacing-100);
    }

    .graduates-work {
      .logos {
        .logo {
          padding: var(--spacing-24) var(--spacing-32);
          margin: 7px;

          svg {
            width: 85px;
          }
        }
      }
    }

    .limited-offer {
      padding-bottom: 0;

      .container {
        border-radius: 0;
        padding: var(--spacing-80) var(--spacing-24);
      }

      .plan-features {
        grid-template-columns: repeat(2, 1fr);

        .feature {
          line-height: 150%;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .affiliate-page {
    .program-cards {
      .heading {
        .h2 {
          max-width: 240px;
        }
      }
    }

    .graduates-work {
      .h2 {
        max-width: 300px;
      }
    }
  }
}
</style>
